import React, { Component } from 'react';
import MaskedInput from 'react-text-mask';

export default class PhoneNumberField extends Component {
    
    getPhoneMask(countryCode) {
        switch (countryCode) {
            case '+55': // Brazil
                return ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]; // (XX) XXXXX-XXXX
            case '+598': // Uruguay  
                return [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]; // XXXX-XXXX
            case '+56': // Chile
                return [/\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]; // X-XXXX-XXXX
            case '+54': // Argentina
                return ['(', /[1-9]/, /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]; // (XXXX) XXX-XXXX
            case '+52': // Mexico
                return ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]; // (XXX) XXX-XXXX
            case '+1': // USA/Canada
            default:
                return ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]; // (XXX) XXX-XXXX
        }
    }

    render() {
        const { inputRef, countryCode, ...other } = this.props;
        const mask = this.getPhoneMask(countryCode);

        return (
            <MaskedInput
                {...other}
                ref={ref => {
                    inputRef(ref ? ref.inputElement : null);
                }}
                mask={mask}                
                placeholderChar={'_'}
                showMask
                key={countryCode} // Force re-render when country code changes
            />
        )
    }
}